<template>
    <div class="style-tab" v-if="channelType !== 1">
        <v-tabs
            v-model="innerValue"
            kind="line"
            align="center"
            class="title-tab"
        >
            <v-tab
                v-for="item in options"
                :key="item.value"
                :value="item.value"
            >
                {{ item.text }}
            </v-tab>
        </v-tabs>
    </div>
</template>
<script>
export default {
    inject: ['channelType'],
    props: {
        value: String,
        options: Array,
    },
    data() {
        return {
            innerValue: this.value,
        };
    },
    watch: {
        value(val) {
            this.innerValue = val;
        },
        innerValue(val) {
            this.$emit('input', val);
        },
    },
    mounted() {
        if(this.channelType === 1) {
            this.innerValue = 'mobile';
        }
    },
};
</script>
<style lang="less" scoped>
.style-tab {
    line-height: 20px;
    font-size: 14px;
    padding: 0 20px 12px;

    .v-tabs {
        .v-tab {
            color: var(--color-deep-gray);
        }
        .is-selected {
            color: var(--black);
            font-weight: 500;
        }
    }
}
</style>
